import { css, cx } from "@emotion/css";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";

export const DefaultScore = ({ className, title }) => {
	if (!title) {
		return (
			<div
				className={css`
          height: 28px;
        `}
			/>
		);
	}

	return (
		<div
			className={cx(
				className,
				"border-radius-8 p-8 size-12 w-fit-content bg-score",
			)}
		>
			{title}
		</div>
	);
};

function DefaultDetails({ className, Score, title, Progress }) {
	return (
		<div className={cx(className, "flex flex-col gap-12 flex-1")}>
			<Score />
			<Tooltip title={title}>
				<h3 className="text-ellipsis-1 m-0 size-16" data-test-id="exam-name">
					{title}
				</h3>
			</Tooltip>
			<Progress />
		</div>
	);
}

export default DefaultDetails;
